module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/powerpoint-ba48d6ffadaea405f73cb4da9321b7c3.svg";